  <template>
  <div class="animated fadeIn">
  <b-breadcrumb><strong>Design Details</strong></b-breadcrumb>
    
  <b-row >
       
    <!----- SideBar All Design List ---->
     <!-- <sidebarSettingsComponent></sidebarSettingsComponent> -->
    <!----- SideBar All Design List End ----> 

     <div class="design-container-details__main">
      <div class="col-md-12 ">

            

            <!-- code for table -->
              <b-row>
                
                <b-col md="12">
                  <b-card-body>
                  <div class="row mt-4"> 
                  </div> 
         
          <b-row class="col-md-12 lgtypelist">            
              <b-col sm="3">
                    <label>Search By</label>
                    <b-form-group  
                      >
                      <b-form-select v-model="selected_search_filter" id="selected_search_filter" name="selected_search_filter" @change="searchFunction">
                        <option :value="selected"  >--Select--</option>
                        <option  :value="search_details.value" v-for="search_details in search_by_arr">{{ search_details.text }}</option>
                    </b-form-select>   
                    </b-form-group>  

              </b-col>
              

              <b-col sm="6" id="search_div" style="display: none">
                <label>Search</label><br>
                    <b-form-group >
                      <!-- <b-input-group> -->

                        <!-- <b-form-input type="text" v-model="selected_search_value" name="selected_search_value" class="form-control" placeholder="Search" aria-label="Search" ></b-form-input>
                        <b-input-group-append>
                          <b-button type="submit" variant="primary"  @click="filterfunction(1)"><i class="fa fa-search" aria-hidden="true" >&nbsp;&nbsp;<b></b></i></b-button>
                          <button class="btn btn-sm btn-primary ml-4" v-on:click="refresh()" type="button"><i class="fa fa-refresh"></i></button>
                        </b-input-group-append> -->

                        <!-- Added Code -->
                        <!-- {{selected_arr}} -->
                        <b-form-input list="selected_search_value" v-model="selected_search_value" name="selected_search_value" placeholder="Please Select."  v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.selected_search_value') }" v-on:keyup="keyHandler($event,selected_search_value)"></b-form-input>
                   <datalist id="selected_search_value">
                    <option :value="selected"></option>
                        <option  :value="list.title" v-for="list in selected_arr"></option>
                  </datalist>
                    <b-input-group class="mb-3">
                        <span class="icon has-text-warning">
                          <i class="fa fa-warning" v-show="errors.has('selected_search_value')" ></i>
                        </span>
                        <code v-show="errors.has('form-1.selected_search_value')" id="statustxt" class="help text-danger">{{ errors.first('form-1.selected_search_value') }}
                        </code>
                        </b-input-group>

                        <b-input-group-append>
                          <b-button type="submit" variant="primary"  @click="filterfunction(1)"><i class="fa fa-search" aria-hidden="true" >&nbsp;&nbsp;<b></b></i></b-button>
                          <button class="btn btn-sm btn-primary ml-4" v-on:click="refresh()" type="button"><i class="fa fa-refresh"></i></button>
                        </b-input-group-append>
                      <!-- </b-form-group> -->
                        <!-- Added Code Ends -->
                      <!-- </b-input-group> -->
                    </b-form-group>
                  </b-col>

            </b-row>


         <!--  <b-col md="12">
             
          </b-col> -->
        
                <b-col sm="12" class="text-right">
                  <button id="button-1"  type="button"  class="btn btn-default btntypelist" @click="styledropdown" style="color: #1b8eb7;font-size: 20px;float:left">
              <i class="fa fa-filter" aria-hidden="true"></i></button>
               <p > <b style="margin-right:5%">Total Records :<span style="color:red;">{{ list_totalRows }}</span></b> </p>
               
              </b-col> 
                <b-tooltip target="button-1" title="Apply Filter"></b-tooltip>

                  <div class="col-md-12 ipad">
                    <b-table class="mt-4" show-empty stacked="md" :busy="isBusy"  :items="search_details"  :fields="fields1"  :current-page="currentPage" :perPage="perPage":bordered="bordered"    :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"    @filtered="onFiltered" >
                  
                    <div slot="table-busy" class="text-center text-danger my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>Loading...</strong>
                    </div>


                    <!-- <template slot="style_image" slot-scope="row"> -->
                      <!-- <img v-bind:src="style_image" style="height:220px width:270px padding:5px;" alt="This image is not available" > -->
                      <!-- <div style="height:220px width:270px padding:5px;"> -->
                      <!-- <img v-bind:src="img_path"/> -->
                      <!-- <img v-bind:src="img_path" alt="No Image To Show" height="220" width="270" style="padding:5px;"/> -->
                    <!-- </div> -->
                      <!-- <div>
                       <b-img v-bind:src="style_details.style_image" ></b-img></div> -->
                      <!-- <img :src="style_image" />  -->
                    <!-- </template> -->

                    <!-- <img v-bind:src="style_details.style_image" id="map" height="220" width="270" style="padding:5px;"/> -->

                    <template slot="actions" slot-scope="row">
                      <i @click="editinfoModal(row.item)"  data-toggle="tooltip" title="Update Vendor Details" class="fa fa-pencil-square-o" aria-hidden="true" style=" color: green;">&nbsp;&nbsp;&nbsp;&nbsp;
                        <!-- <i class="fa fa-edit"></i> -->
                      </i>
                      <i  v-on:click="deleteinfoModal(row.item)"  data-toggle="tooltip" title="Delete Vendor Details"  class="fa fa-trash" aria-hidden="true" style="color: red">
                         <!-- <i class="fa fa-trash" aria-hidden="true" style="color: red"></i> -->
                      </i>

                    </template>    
                    <template slot="action" slot-scope="row">
                      <!-- <button type="button" class="btn btn-info" style="width: 110px;" @click="opendesignModal(row.item)">Info</button> -->
                        <b-col md="12" class="pull-right text-right">
                          <!-- <div class="pull-right"> -->
                        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret >
                        <template v-slot:button-content>
                          <button @click="getrowdata(row.item)" style="border: none;" class="btn btn-link"><span class="cui-options icons font-1xl d-block" style="font-size: 15px;"></span></button>
                        </template>
                          <b-dropdown-item 
                          
                          target="_blank" >
                          <button v-b-modal.modal-lg type="button" class="btn btn-link" @click="opendesignModal(row.item)" v-if="user_type=='Design_Head' || user_type=='Admin'  || user_type=='Quality_Head'" ><i class="fa fa-address-card-o" variant="primary" aria-hidden="true" style="color: green; margin-left: 5px;" ></i>Style Details</button>
                          <router-link :to="'/design_details/' + route_id" v-if="user_type=='Brand_Manager' || 'Fit_Technician'  || user_type=='Buyer' || user_type=='Brand_Designer' || user_type=='Quality_Controller'|| user_type=='Quality_Executive'" ><b-button type="submit" variant="primary" ><i class="fa fa-address-card-o" variant="primary" aria-hidden="true" style="color: green; margin-left: 5px;" ></i>Style Details</b-button>
                          </router-link>
                        </b-dropdown-item>

                          </b-dropdown-item>
                        </b-dropdown>
                      <!-- </div> -->
                        </b-col>
                    </template>        
                  </b-table>
                </div>
                      <b-col md="6" class="my-1">
                <!-- <b-pagination
                  v-model="currentPage"
                  :total-rows="list_totalRows"
                  :per-page="perPage"
                  class="my-0"
                ></b-pagination> -->
                <paginate
   
                  :page-count="noofpages"
                  :page-range="10"
                  :margin-pages="2"
                  :click-handler="clickCallback"
                  :prev-text="'Prev'"
                  :next-text="'Next'"
                  :container-class="'pagination'"
                  :page-class="'page-item'">
                </paginate>
              </b-col>      
            <!-- Info modal -->         
                 <!-- </div> -->

                  </b-card-body>
               </b-col>
            </b-row>          
             <!-- code for table ends -->
             <!-- Dropdown Modal for small -->


             <!-- Code For Design Details Model -->
      <b-modal id="modal-lg" size="xl" title="Design Details" v-model="showdesigndetails" @ok="showdesigndetails = false">
      <b-row>
         <b-col sm="12">
          <button style="color: #1b8eb7;font-size: 12px;float:right" class="btn btn-default tablechart" @click="opentable" ><i v-b-tooltip.hover title="Measurement Chart" class="fa fa-table" aria-hidden="true"></i></button>
        </b-col>
    
      <b-col sm="12" class='col-md-12'>
        
        <b-form name="addSegmentForm" @submit.prevent="updatestylestatus(comment,status)" >

                 <!-- <b-row class="col-md-12">
          
        </b-row> -->
         <b-row class="col-md-12">
            
            <b-col cols="4">
               <div class="detailimgborder">
                  <img v-bind:src="img_path" alt="No Image To Show" class="detailsmodalimg"/>
                   <button v-b-modal.modal-lg type="button" class="btn btn-success summaryzoombtn" ><i class="fa fa-search-plus" aria-hidden="true">&nbsp;Zoom Image</i></button>
                  <!-- <image-magnifier :src="img_path"
                    :zoom-src="img_path"
                    width="400"
                    height="300"
                    zoom-width="400"
                    zoom-height="300" style="padding:5px;"></image-magnifier> -->
                  <!-- <b-form-group style="margin-top:25px;">
                        
                    <b-form-group>
                        <b-col md="9">
                        </b-col>
                      <b-col md="3" class="pull-right"><img v-bind:src="img_path" height="100px" width="100px" /></b-col></b-form-group>
                    
                  </b-form-group>     -->              
               </div>

              
                  
              

            </b-col>


            <b-col cols="2"></b-col>

            <b-col cols="6" class="designsummaryipad">
              
               
              <div  class='col-md-12 designsummary' >    

                <!-- <b-col md="6" class="pull-left"> -->
                  <b-form-group>
                    <b-col md="5" class="pull-left designsummarycol5">
                     <label for="name"><b>Brand Title</b></label>
                   </b-col> 
                   <b-col md="1" class="pull-left designsummarycol1"><b>:</b></b-col>
                    
                   <b-col md="6" class="pull-right summarymodel" >{{customer.brand_title}}
                   </b-col>
                  </b-form-group>

                  <b-form-group>
                    <b-col md="5" class="pull-left designsummarycol5">
                     <label for="name"><b>Style Code</b></label>
                   </b-col> 
                   <b-col md="1" class="pull-left designsummarycol1"><b>:</b></b-col>
                    
                   <b-col md="6" class="pull-right summarymodel" >{{style_details.style_code}}
                   </b-col>
                  </b-form-group>

                  <b-form-group >
                    <b-col md="5" class="pull-left designsummarycol5">
                     <label for="name"><b>Segment Title</b></label>
                   </b-col> 
                   <b-col md="1" class="pull-left designsummarycol1"><b>:</b></b-col>
                    
                   <b-col md="6" class="pull-right summarymodel" >{{style_details.segment_title}}
                   </b-col>
                  </b-form-group>

                  <b-form-group >
                    <b-col md="5" class="pull-left designsummarycol5">
                     <label for="name"><b>Collection Title</b></label>
                   </b-col> 
                   <b-col md="1" class="pull-left designsummarycol1"><b>:</b></b-col>
                    
                   <b-col md="6" class="pull-right summarymodel" >{{customer.collection_title}}
                   </b-col>
                  </b-form-group>

                  <b-form-group >
                    <b-col md="5" class="pull-left designsummarycol5">
                     <label for="name"><b>Sub Category Title</b></label>
                   </b-col> 
                   <b-col md="1" class="pull-left designsummarycol1"><b>:</b></b-col>
                    
                   <b-col md="6" class="pull-right summarymodel" >{{style_details.sub_cattitle}}
                   </b-col>
                  </b-form-group>

                  <b-form-group>
                    <b-col md="5" class="pull-left designsummarycol5">
                     <label for="name"><b>Style Name</b></label>
                   </b-col> 
                   <b-col md="1" class="pull-left designsummarycol1"><b>:</b></b-col>
                    
                   <b-col md="6" class="pull-right summarymodel" >{{style_details.style_name}}
                   </b-col>
                  </b-form-group>


                  <b-form-group v-if="user_type!='Admin'">
                    <b-col md="5" class="pull-left designsummarycol5">
                     <label for="name"><b>PO Type</b></label>
                   </b-col> 
                   <b-col md="1" class="pull-left designsummarycol1"><b>:</b></b-col>
                    
                   <b-col md="6" class="pull-right summarymodel" >{{style_details.potype_title}}
                   </b-col>
                  </b-form-group>
                  <b-form-group v-if="user_type!='Admin'">
                    <b-col md="5" class="pull-left designsummarycol5">
                     <label for="name"><b>Utility Type</b></label>
                   </b-col> 
                   <b-col md="1" class="pull-left designsummarycol1"><b>:</b></b-col>
                    
                   <b-col md="6" class="pull-right summarymodel" >{{style_details.utilitytype_title}}
                   </b-col>
                  </b-form-group>
              </div>
            </b-col>

            <b-col cols="6">
               <!-- <div style="float: left;
                  border: 1px solid lightgray;"> -->
                              <!-- Added Code for Size Set -->
            <div  class="col-md-12 summarytableset" id="sizesetData" v-if="user_type!='Admin'">
              
              <b-row>
                <b-form  >
                  <!-- <table class="table table-striped">
            <thead>
              <tr>
                <td scope="col" style="width: 10%">Size Set</td>                
                <td scope="col" style="width: 20%">Unit</td>
                <td scope="col" style="width: 15%">Age From</td>
                <td scope="col" style="width: 15%">Age To</td>
                <td scope="col" style="width: 17%">Factory Size(In CM / In Inch)</td>
                <td scope="col" style="width: 17%">Quantity</td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(invoice_product, index) in sizeset">
                <td ><label>Size &nbsp;</label>{{index+1}}</td>
                
                <td>
                    <b-form-select :plain="true" name="selected_month" required v-model="selected_month[index]" :options="unit_arr"  @change="changeMonthYearVal($event,index)" disabled readonly >
                    </b-form-select>
                    
                </td>

                <td>
                  <b-form-select  :plain="true" name="selectedfromage"  v-model="selectedfromage[index]" required :options="month_arr" :class="{'input': true, 'text-danger': errors.has('selectedfromage[index]') }"  disabled readonly>
                  </b-form-select>

                               
                </td>
                
                <td > 

                  <b-form-select    :plain="true" v-model="selectedtoage[index]" :options="to_month_arr"  required @change="checkagevalue(selectedfromage[index],selectedtoage[index], index)" disabled readonly>
                  </b-form-select> 

                </td>

                <td >
                  <b-form-input type="text" name="factorysize"   v-model="factorysize[index]" :key="index"  required disabled readonly></b-form-input>
                </td>

                <td >
                 
                  <b-form-input type="text" name="quantity"   v-model="quantity[index]" :key="index"  required disabled readonly></b-form-input>
                </td>
              </tr>
            </tbody>
          </table> -->
          <table class="table table-striped">
            <thead>
              <tr>
                <td scope="col" style="width: 10%">Size Set</td>                
                <td scope="col" style="width: 20%">Unit</td>
                <td scope="col" style="width: 15%">Age From</td>
                <td scope="col" style="width: 15%">Age To</td>
                <td scope="col" v-if="selected_status_code_number>=12 && selected_status_code_number!=13" style="width: 17%">Factory Size(In CM / In Inch)</td>
                <td scope="col" v-if="selected_status_code_number>=15" style="width: 17%">Quantity</td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(tbl_invoice_product, index) in sizeset">
                <td ><label>Size &nbsp;</label>{{index+1}}</td>
                
                <td>
                    <b-form-select :plain="true" name="tbl_selected_month" required v-model="tbl_selected_month[index]" :options="unit_arr" disabled readonly >
                    </b-form-select>
                    
                </td>

                <td>
                  <b-form-select  :plain="true" name="tbl_selectedfromage"  v-model="tbl_selectedfromage[index]" required :options="month_arr"  disabled readonly>
                  </b-form-select>

                               
                </td>
                
                <td > 

                  <b-form-select    :plain="true" v-model="tbl_selectedtoage[index]" :options="to_month_arr"  required disabled readonly>
                  </b-form-select> 

                </td>

                <td v-if="selected_status_code_number>=12 && selected_status_code_number!=13">
                  <b-form-input type="text" name="tbl_factorysize"   v-model="tbl_factorysize[index]" :key="index"  required disabled readonly></b-form-input>
                </td>

                <td v-if="selected_status_code_number>=15">
                  <b-form-input type="text" name="tbl_quantity"   v-model="tbl_quantity[index]" :key="index"  required disabled readonly></b-form-input>
                </td>
              </tr>
            </tbody>
          </table>
                </b-form>
                  </b-row>
                    
            </div>

            <!-- Added Code for Size Set Ends -->          
               <!-- </div> -->

              
                  
              

            </b-col>


            <!-- <b-col cols="2"></b-col> -->

            <b-col cols="6" class="designsummaryipad">
              
               
              <div  class='col-md-12 designsummary' > 

                  

                  <b-form-group v-if="user_type!='Admin'">
                    <b-col md="5" class="pull-left designsummarycol5">
                     <label for="name"><b>No of Size Sets</b></label>
                   </b-col> 
                   <b-col md="1" class="pull-left designsummarycol1"><b>:</b></b-col>
                    
                   <b-col md="6" class="pull-right summarymodel" >{{style_details.no_of_sizeset}}
                   </b-col>
                  </b-form-group>

                  <b-form-group v-if="user_type!='Admin'">
                    <b-col md="5" class="pull-left designsummarycol5">
                     <label for="name"><b>Color</b></label>
                   </b-col> 
                   <b-col md="1" class="pull-left designsummarycol1"><b>:</b></b-col>
                    
                   <b-col md="6" class="pull-right summarymodel" >{{style_details.color}}
                   </b-col>
                  </b-form-group>

                  <b-form-group v-if="user_type!='Admin'">
                    <b-col md="5" class="pull-left designsummarycol5">
                     <label for="name"><b>Operational Status</b></label>
                   </b-col> 
                   <b-col md="1" class="pull-left designsummarycol1"><b>:</b></b-col>
                    
                   <b-col md="6" class="pull-right summarymodel" >{{style_details.operational_status}}
                   </b-col>
                  </b-form-group>

                  <b-form-group v-if="user_type!='Admin'">
                    <b-col md="5" class="pull-left designsummarycol5">
                     <label for="name"><b>Design Status</b></label>
                   </b-col> 
                   <b-col md="1" class="pull-left designsummarycol1"><b>:</b></b-col>
                    
                   <b-col md="6" class="pull-right summarymodel" >{{style_details.design_status}}
                   </b-col>
                  </b-form-group>

                  <b-form-group v-if="user_type!='Admin'">
                    <b-col md="5" class="pull-left designsummarycol5">
                     <label for="name"><b>Created By</b></label>
                   </b-col> 
                   <b-col md="1" class="pull-left designsummarycol1"><b>:</b></b-col>
                    
                   <b-col md="6" class="pull-right summarymodel" >{{style_details.full_name}}
                   </b-col>
                  </b-form-group>  

                  <b-form-group v-if="user_type!='Admin'">
                    <b-col md="5" class="pull-left designsummarycol5">
                     <label for="name"><b>Designer Name</b></label>
                   </b-col> 
                   <b-col md="1" class="pull-left designsummarycol1"><b>:</b></b-col>
                    
                   <b-col md="6" class="pull-right summarymodel" >{{style_details.designer_name}}
                   </b-col>
                  </b-form-group>

                  <b-form-group v-if="user_type!='Admin'">
                    <b-col md="5" class="pull-left designsummarycol5">
                     <label for="name"><b>Fit Tech Name</b></label>
                   </b-col> 
                   <b-col md="1" class="pull-left designsummarycol1"><b>:</b></b-col>
                    
                   <b-col md="6" class="pull-right summarymodel" >{{style_details.fit_tech_name}}
                   </b-col>
                  </b-form-group>

                  <b-form-group v-if="user_type!='Admin'">
                    <b-col md="5" class="pull-left designsummarycol5">
                     <label for="name"><b>Buyer Name</b></label>
                   </b-col> 
                   <b-col md="1" class="pull-left designsummarycol1"><b>:</b></b-col>
                    
                   <b-col md="6" class="pull-right summarymodel" >{{style_details.buyer_name}}
                   </b-col>
                  </b-form-group>

                  <b-form-group v-if="user_type!='Admin'">
                    <b-col md="5" class="pull-left designsummarycol5">
                     <label for="name"><b>Created Date</b></label>
                   </b-col> 
                   <b-col md="1" class="pull-left designsummarycol1"><b>:</b></b-col>
                    
                   <b-col md="6" class="pull-right summarymodel" >{{style_details.created_date}}
                   </b-col>
                  </b-form-group>

                  <b-form-group v-if="user_type!='Admin'">
                    <b-col md="5" class="pull-left designsummarycol5">
                     <label for="name"><b>Updated Date</b></label>
                   </b-col> 
                   <b-col md="1" class="pull-left designsummarycol1"><b>:</b></b-col>
                    
                   <b-col md="6" class="pull-right summarymodel" >{{style_details.updated_date}}
                   </b-col>
                  </b-form-group>

                  <b-form-group v-if="user_type!='Admin'">
                    <b-col md="5" class="pull-left designsummarycol5">
                     <label for="name"><b>Style Description</b></label>
                   </b-col> 
                   <b-col md="1" class="pull-left designsummarycol1"><b>:</b></b-col>
                    
                   <b-col md="6" class="pull-right summarymodel" >{{style_details.style_description}}
                   </b-col>
                  </b-form-group>

                </div>  
               
            </b-col>
         </b-row>
            <b-row>
        <div  class="col-md-12 tablemd" id="tablesm">
              
              <!-- <b-row> -->
                <b-form  >
             
          <table class="table table-striped">
            <thead>
              <tr>
                <td scope="col" style="width: 10%">Size Set</td>                
                <td scope="col" style="width: 20%">Unit</td>
                <td scope="col" style="width: 15%">Age From</td>
                <td scope="col" style="width: 15%">Age To</td>
                <td scope="col" v-if="selected_status_code_number>=12 && selected_status_code_number!=13" style="width: 17%">Factory Size(In CM / In Inch)</td>
                <td scope="col" v-if="selected_status_code_number>=15" style="width: 17%">Quantity</td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(tbl_invoice_product, index) in sizeset">
                <td ><label>Size &nbsp;</label>{{index+1}}</td>
                
                <td>
                    <b-form-select :plain="true" name="tbl_selected_month" required v-model="tbl_selected_month[index]" :options="unit_arr" disabled readonly >
                    </b-form-select>
                    
                </td>

                <td>
                  <b-form-select  :plain="true" name="tbl_selectedfromage"  v-model="tbl_selectedfromage[index]" required :options="month_arr"  disabled readonly>
                  </b-form-select>

                               
                </td>
                
                <td > 

                  <b-form-select :plain="true" v-model="tbl_selectedtoage[index]" :options="to_month_arr"  required disabled readonly>
                  </b-form-select> 

                </td>

                <td v-if="selected_status_code_number>=12 && selected_status_code_number!=13">
                  <b-form-input type="text" name="tbl_factorysize"   v-model="tbl_factorysize[index]" :key="index"  required disabled readonly></b-form-input>
                </td>

                <td v-if="selected_status_code_number>=15">
                  <b-form-input type="text" name="tbl_quantity"   v-model="tbl_quantity[index]" :key="index"  required disabled readonly></b-form-input>
                </td>
              </tr>
            </tbody>
          </table>
                </b-form>
                  <!-- </b-row> -->
                    
            </div>
          </b-row>
            

                    
                 

              <!-- </div> -->
            
            <div slot="footer"  style="margin-top:20px;text-align:right" v-if="(style_details.operational_status=='StyleNoCreated' || style_details.operational_status=='BH-approved') && user_type!='Buyer'">
            
              <b-form-group
                  label="Comment"
                  :label-cols="3" >
                  <b-form-textarea rows="3" max-rows="6" v-model="comment" type="text" name="comment"  
                  placeholder="Enter Comment Here...">
                  </b-form-textarea><br>
                  <b-input-group class="mb-3">
                      <label class="radio-inline"><input type="radio" name="optradio" value="approved" v-model="status" checked>&nbsp;Approved</label>&nbsp;&nbsp;
                      <label class="radio-inline"><input type="radio" name="optradio" value="rejected" v-model="status">&nbsp;Reject</label>&nbsp;&nbsp;

                      <label class="radio-inline"><input type="radio" name="optradio" value="Feedback" v-model="status">&nbsp;Feedback</label>                       
                    &nbsp;&nbsp;
                      </b-input-group>
                                 
                </b-form-group>
                <div slot="footer" class="text-right">
                  <b-button type="submit" size="sm" class="mr-4" variant="primary"> Update Status</b-button>
                  <b-button  size="sm" variant="danger" @click="commentcancel()">cancel</b-button>
                </div>

            </div>
         </b-form>
      </b-col>

    </b-row>
    </b-modal>
             <!-- Code For Design Details Ends -->
 <b-modal  size="xl" title="Table Set" v-model="opentablemodel" @ok="opentablemodel = false">
          <template slot="modal-header">
          <h5>Measurement Chart</h5>
        </template>
            <!-- <template slot="default" slot-scope="{ hide }">
            <div>
              Hiiiiiiiiii
            </div>
          </template> -->
          <!-- <b-button  size="sm"  @click="openimagecancel()" style="background: none; border: none;"><i class="fa fa-close"></i></b-button>
          </template> -->
          <template slot="default">
         <!--    <div>
              <span style="color:red;padding:10px"><b>N.B&nbsp;:</b>&nbsp;M- Month & Y- Year</span>
            </div> -->
            <b-row style="overflow:auto">
                      <b-form  >
             
          <table class="table table-striped">
            <thead>
              <tr>
                <td scope="col"  class="sumtdhset" >Size Set</td>                
                <td scope="col"  class="sumtdhunit" >Unit</td>
                <td scope="col"  class="sumtdhagefrom" >Age From</td>
                <td scope="col"  class="sumtdhageto" >Age To</td>
                <td scope="col"  class="sumtdhsize"  v-if="selected_status_code_number>=12 && selected_status_code_number!=13" style="width: 17%">Factory Size(In CM / In Inch)</td>
                <td scope="col"  class="sumtdhquantity"  v-if="selected_status_code_number>=15" style="width: 17%">Quantity</td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(tbl_invoice_product, index) in sizeset">
                <td ><label class="sumtdbset">Size &nbsp;</label>{{index+1}}</td>
                
                <td>
                    <b-form-select class="sumtdbunit" :plain="true" name="tbl_selected_month" required v-model="tbl_selected_month[index]" :options="unit_arr" disabled readonly >
                    </b-form-select>
                    
                </td>

                <td>
                  <b-form-select class="sumtdbfage" :plain="true" name="tbl_selectedfromage"  v-model="tbl_selectedfromage[index]" required :options="month_arr"  disabled readonly>
                  </b-form-select>

                               
                </td>
                
                <td > 

                  <b-form-select class="sumtdbtage"   :plain="true" v-model="tbl_selectedtoage[index]" :options="to_month_arr"  required disabled readonly>
                  </b-form-select> 

                </td>

                <td v-if="selected_status_code_number>=12 && selected_status_code_number!=13">
                  <b-form-input type="text" class="sumtdbsize" name="tbl_factorysize"   v-model="tbl_factorysize[index]" :key="index"  required disabled readonly></b-form-input>
                </td>

                <td v-if="selected_status_code_number>=15">
                  <b-form-input type="text" class="sumtdbquantity" name="tbl_quantity"   v-model="tbl_quantity[index]" :key="index"  required disabled readonly></b-form-input>
                </td>
              </tr>
            </tbody>
          </table>
                </b-form>
                  </b-row>
       <div slot="footer" class="text-right">
                 <!--  <b-button type="submit" size="sm" class="mr-4" variant="primary"> Update</b-button> -->
                  <b-button  size="sm" variant="danger" @click="opentablecancel()">cancel</b-button>
                </div>
          </template>
              
          <template slot="modal-footer" slot-scope="{ hide }">
            
            <b-button size="sm" style="display:none">
              Cancel
            </b-button>
            
          </template>
      </b-modal> 
          <!-- Image Zoom Model -->
    <b-modal id="modal-lg" size="lg" title="Image Zoom" v-model="openimagemodel" @ok="openimagemodel = false">
          <template slot="modal-header">
          <h5>Zoom Image</h5>
          <!-- <button type="button" class="close" aria-label="Close"  slot-scope="{ hide }">
            <span aria-hidden="true">&times;</span>
          </button> -->
          <b-button  size="sm"  @click="openimagecancel()" style="background: none; border: none;"><i class="fa fa-close"></i></b-button>
          </template>
          <template slot="default" slot-scope="{ hide }">
            <div id="btn_navbar">
              <button type="button" class="btn btn-success" @click="zoomin()"><i class="fa fa-search-plus" aria-hidden="true">&nbsp;Zoom In</i></button>&nbsp;
              <button type="button" class="btn btn-danger" @click="zoomout()"><i class="fa fa-search-minus" aria-hidden="true">&nbsp;Zoom Out</i></button>
              </div>

              <div class="main1" style="text-align: center;">
              <img v-bind:src="style_details.style_image" id="map" height="220" width="270" style="padding:5px;"/>
              </div>


            

                <div slot="footer" class="text-right">
                 <!--  <b-button type="submit" size="sm" class="mr-4" variant="primary"> Update</b-button> -->
                  <b-button  size="sm" variant="danger" @click="openimagecancel()">cancel</b-button>
                </div>

          </template>
          <template slot="modal-footer" slot-scope="{ hide }">
            
            <b-button size="sm" style="display:none">
              Cancel
            </b-button>
            
          </template>
      </b-modal> 
            <!-- Image Zoom Model -->

 
      </div>
    </div>     
      
  </b-row>    





    
  </div>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import auth from '@/utils/auth'
import Vue from 'vue'
import ImageMagnifier from 'vue-image-magnifier'
Vue.use(ImageMagnifier)
// import { EventBus } from "./event-bus.js";


import sidebarSettingsComponent from './_sidebarSettingsComponent.vue'

const axios = require('axios')
export default {
  name: 'Tabs',
 components: {
    sidebarSettingsComponent
  },
  // mounted() {  
    
  //     EventBus.$on("clicked-event", pid=> {  
  
  // this.displaydata(); 
  //     });  
  //  }  ,  
  data () {
    return {
      isBusy: false,  
      sampelAddModal: false,    
      customer: {},
      addAgentMaster : false,
      editAgentMaster:false,
      bordered: true,
      showSideMenu:true,
      items:[],
      result:[],
      value:[],
      sortDesc: true,
      sortDirection: 'desc',
      fields1: [
          // { key: 'brand_title', label: 'Brand Title', sortable: true, sortDirection: 'desc' },
          // { key: 'segment_title', label: 'Segment Title', sortable: true},
          //  { key: 'collection_title', label: 'Collection Title', sortable: true},
            { key: 'design_title', label: 'Design Name' ,class: 'design'},
            
            { key: 'sub_cattitle', label: 'Subcat Title',class: 'design'},
            { key: 'potype_title', label: 'PO Type',class: 'design'},
            { key: 'designer_name', label: 'Designer Name',class: 'design'},
            // { key: 'style_image', label: 'Style Image'},
            { key: 'operational_status', label: 'Status',class: 'design'},
            { key: 'comments', label: 'Section Feedback',class: 'design'},
          { key: 'action', label: 'Action' ,class: 'design'},
         
      
       ],
       // opendropdownmodel: false,
       showdesigndetails: false,
       currentPage: 1,
       // perPage:  10,
       sortBy: null,
       sortDesc: true,
       sortDirection: 'desc',
       filter: null,
       totalRows: 0,
       list_totalRows: 0,
       selected_style_id: 0,
       style_details: [],
       img_path: '',
       status: '',
       comment: '',
       selected: '',
       style_name_arr: [],
       brand_title_arr: [],
       segment_title_arr: [],
       collection_title_arr: [],
       brand_title: '',
       showfeedbackmodel: false,
       feedback: '',
       route_id: 0,
       user_type: '',
        opentablemodel:false,
       openimagemodel: false,
       style_image: '',
       po_typearr: [],
       selected_po_id: 0,
       utility_type_arr: [],
       // search_by_arr : [],
       selected_subcat_id: 0,
       sub_cat: 0,
       selected_po_id: 0,
       selected_utility_id: 0,
       route_id: '',
       search_item: '',
       search_by_arr: [
          { value: 'style_name', text: 'Style Name' },
          { value: 'style_id', text: 'Style ID' },
          { value: 'style_code', text: 'Style Code' },
          { value: 'story_name', text: 'Story Name' },
          { value: 'brand_name', text: 'Brand Name' },
          { value: 'vendor_name', text: 'Vendor Name' },
          { value: 'vendor_email', text: 'Vendor Email ID' },
          // { value: 'po_number', text: 'PO Number' },
          // { value: 'warehouse_name', text: 'Warehouse Name' },
          // { value: 'fcid', text: 'FCID' },
          { value: 'segment', text: 'Segment' },
          { value: 'sub_category', text: 'Sub Category' },
          { value: 'po_type', text: 'PO Type' },
          { value: 'utility_type', text: 'Utility Type' },
          
          
          
          
       ],
       selected: '',
       search_subcat: 0,
       search_utility: 0,
       search_po: 0,
        sizeset: [],
        invoice_products:[{
              unit: [],
              selectedfromage: [],
              selectedtoage: [],
              quantity: [],
              factorysize: [],
            }
          ],
        selected_month: [],
        selected_age: 0,
        selectedfromage:[],
        selectedtoage: [],
        quantity: [],
        factorysize: [],
        unit_arr: [
          { value: '0', text: 'Month' },
          { value: '1', text: 'Year' }
          ],
         month_arr: [
              { value: '1', text: '1' },
              { value: '2', text: '2' },
              { value: '3', text: '3' },
              { value: '4', text: '4' },
              { value: '5', text: '5' },
              { value: '6', text: '6' },
              { value: '7', text: '7' },
              { value: '8', text: '8' },
              { value: '9', text: '9' },
              { value: '10', text: '10' },
              { value: '11', text: '11' },
              { value: '12', text: '12' },
              { value: '13', text: '13' },
              { value: '14', text: '14' },
              { value: '15', text: '15' },
              { value: '16', text: '16' },
              { value: '17', text: '17' },
              { value: '18', text: '18' },
              { value: '19', text: '19' },
              { value: '20', text: '20' },
              { value: '21', text: '21' },
              { value: '22', text: '22' },
              { value: '23', text: '23' },
              { value: '24', text: '24' }
            ],      
          year_arr: [
              { value: '1', text: '1' },
              { value: '2', text: '2' },
              { value: '3', text: '3' },
              { value: '4', text: '4' },
              { value: '5', text: '5' },
              { value: '6', text: '6' },
              { value: '7', text: '7' },
              { value: '8', text: '8' },
              { value: '9', text: '9' },
              { value: '10', text: '10' },
              { value: '11', text: '11' },
              { value: '12', text: '12' }          
              ],
          to_month_arr: [
              { value: '1', text: '1' },
              { value: '2', text: '2' },
              { value: '3', text: '3' },
              { value: '4', text: '4' },
              { value: '5', text: '5' },
              { value: '6', text: '6' },
              { value: '7', text: '7' },
              { value: '8', text: '8' },
              { value: '9', text: '9' },
              { value: '10', text: '10' },
              { value: '11', text: '11' },
              { value: '12', text: '12' },
              { value: '13', text: '13' },
              { value: '14', text: '14' },
              { value: '15', text: '15' },
              { value: '16', text: '16' },
              { value: '17', text: '17' },
              { value: '18', text: '18' },
              { value: '19', text: '19' },
              { value: '20', text: '20' },
              { value: '21', text: '21' },
              { value: '22', text: '22' },
              { value: '23', text: '23' },
              { value: '24', text: '24' }
            ],      
          to_year_arr: [
              { value: '1', text: '1' },
              { value: '2', text: '2' },
              { value: '3', text: '3' },
              { value: '4', text: '4' },
              { value: '5', text: '5' },
              { value: '6', text: '6' },
              { value: '7', text: '7' },
              { value: '8', text: '8' },
              { value: '9', text: '9' },
              { value: '10', text: '10' },
              { value: '11', text: '11' },
              { value: '12', text: '12' }          
              ],
              tbl_selected_month:[],
          tbl_selectedfromage:[],
          tbl_selectedtoage:[],
          tbl_invoice_products:[{
            tbl_unit: [],
            tbl_selectedfromage: [],
            tbl_selectedtoage: [],
            tbl_factorysize: [],
            tbl_quantity: [],
          }
            ],

            tbl_unit: [],
            tbl_selectedfromage: [],
            tbl_selectedtoage: [],
            tbl_factorysize: [],
            tbl_quantity:[],
            selected_status_code_number: 0,
            access_token: '',
            selected_search_value: '',
            search_details: [],
            perPage:  20,
            pageNum:1,
            noofpages:'',
            pageOptions: [5, 10, 15],
            selected_arr: [],
   }

  },
  created: function() { 
  var userData = localStorage.getItem('userData');
  var userInfo = JSON.parse(userData);
  this.access_token=userInfo[0]['token']
  axios.defaults.headers.common['x-access-token'] = this.access_token;
  axios.defaults.headers.common['Content-Type'] = 'application/json;charset=UTF-8'
  axios.defaults.headers.common['Accept']= 'application/json';
  axios.defaults.headers.common['Origin']='http://localhost:8080';
  this.user_type= userInfo[0].user_type;
  this.sub_cat_id_arr=userInfo[0].subcat_assign;
  this.route_id=this.$route.params.id;
 
  },
 computed: {
      sortOptions() {
        // Create an options list from our fields
        return this.fields1
          .filter(f => f.sortable)
          .map(f => {
            return { text: f.label, value: f.key }
          })
      }
    },

  
  methods: 
  {  
    keyHandler: function(event,txt_val){
      // txt_val.length
      // alert(txt_val.length)
      if(txt_val.length>=3){
      const Obj={
      // selected_filter: this.selected_search_filter
      selected_filter:this.selected_search_filter,
        text_value:txt_val
      }
    
              console.log("XXXXXXXXXXXXXXXXXXXXXXXXX",Obj);

    axios.post(`${CONSTANTS.API_URL}/getFilteredList`,Obj)
      .then(response => {

        document.getElementById("overlay").style.display = "none";
        this.result = response.data

        if (this.result.returnmsg === 'Successful') {
          this.selected_arr  = this.result.returnvalue;
         console.log("AAAAAAAAAAAAAAAAAA",this.selected_arr)
          
        }else {
         this.selected_arr =[];
         // this.totalRows=0;
        }


      })
      .catch(e => {
        this.errors.push(e)
      })
      }
    },
    clickCallback (pageNum)
       {
         //alert(" i m in pagination task");
      // alert(pageNum)
      this.filterfunction(pageNum);
    },
    closefeedback: function(){
      this.showfeedbackmodel = !this.showfeedbackmodel;
    },
      getrowdata(value) {
          this.route_id=value.style_id; 
   },
   searchFunction: function(){
    // document.getElementById("overlay").style.display = "block";
     document.getElementById("search_div").style.display = "block";
    const Obj={
      selected_filter: this.selected_search_filter
    }
              console.log("XXXXXXXXXXXXXXXXXXXXXXXXX",Obj);

    axios.post(`${CONSTANTS.API_URL}/getFilteredList`,Obj)
      .then(response => {

        document.getElementById("overlay").style.display = "none";
        this.result = response.data

        if (this.result.returnmsg === 'Successful') {
          this.selected_arr  = this.result.returnvalue;
         console.log("AAAAAAAAAAAAAAAAAA",this.selected_arr)
          
        }else {
         this.selected_arr =[];
         // this.totalRows=0;
        }


      })
      .catch(e => {
        this.errors.push(e)
      })
   },
   filterfunction: function(page_no){
    this.search_details=[];
    document.getElementById("overlay").style.display = "block";
    const Obj={
          limit:"10",
          page_no:page_no,
        searchBy: this.selected_search_filter,
        search_value: this.selected_search_value
      } 
      console.log("SSSSSSSSSSSSSSSSSSSSSSSSSS",Obj);
  
    axios.post(`${CONSTANTS.API_URL}/searchByFilters`,Obj)
      .then(response => {
        document.getElementById("overlay").style.display = "none";
        this.result = response.data

        if (this.result.returnmsg === 'Successful') {
          this.search_details  = this.result.returnvalue[0].filterResultInfo;
          // this.totalRows = this.result.returnvalue.length;
          
          this.list_totalRows =this.result.returnvalue[1].totalrecords[0].count;
             // console.log(this.totalRows)
             this.noofpages=parseInt(this.list_totalRows)/20;
              this.noofpages=Math.ceil( this.noofpages);
              // alert(this.noofpages)
          
          
        }else {
         this.search_details =[];
         this.list_totalRows=0;
        }


      })
      // .catch(e => {
      //   this.errors.push(e)
      // })
   },
   refresh: function(){
      this.selected_subcat_id= '';
      this.selected_utility_id= '';
      this.selected_po_id= '';
      this.search_item='';
      this.search_po=0;
      this.search_utility=0;
      this.search_subcat=0;
      // this.search_item=0;
      this.getdesignheadstyledetails(); 
    },

     /******Function To Get Sub Category List********/
      getSubCategoryList: function(value) {    
       
      axios.post(`${CONSTANTS.API_URL}/getSubCategoryList`,{})
      .then(response => {
        //document.getElementById("overlay").style.display = "none";
        this.result = response.data

        if (this.result.returnmsg === 'Successful') {
          this.sub_cat_id_arr  = this.result.returnvalue;
          this.totalRows = this.result.returnvalue.length;
          
          
        }else {
         this.sub_cat_arr =[];
         this.totalRows=0;
        }


      })
      .catch(e => {
        this.errors.push(e)
      })
    },


   subcatsearch: function(value){
    this.search_subcat=0;
    this.search_subcat= value;
    this.getdesignheadstyledetails();
   },
   utilitysearch: function(value){
    this.search_utility= 0;
    this.search_utility=value;
    this.getdesignheadstyledetails();
   },
   posearch: function(value){
    this.search_po=0;
    this.search_po=value;
    this.getdesignheadstyledetails();
   },



   changesubcat(id){
    this.sub_cat= id;
    this.getUtilityTypeList();
    this.getPoTypeList();
   },

     /******Function To Get Utility Type List********/
      getUtilityTypeList: function() {
        // document.getElementById("overlay").style.display = "block";
        
      this.isBusy = true;  
      const Obj={
        subcat_id: this.sub_cat
      }   
      axios.post(`${CONSTANTS.API_URL}/getUtilityTypeList`,Obj)
      .then(response => {
        this.result = response.data

        if (this.result.returnmsg === 'Successful') {
          // document.getElementById("overlay").style.display = "none";
          this.utility_type_arr  = this.result.returnvalue;
          console.log("this.utility_type_arr",this.utility_type_arr);
          this.totalRows = this.result.returnvalue.length;
          this.isBusy = !this.isBusy;
          
        }else {
         this.utility_type_arr =[];
         this.totalRows=0;
           // this.isBusy = !this.isBusy;
        }


      })
      .catch(e => {
        this.errors.push(e)
      })
    },

  /******Function To Get Utility Type List Ends********/


  /******Function To Get PO Type List********/
      getPoTypeList: function() {
        // document.getElementById("overlay").style.display = "block";
       
      this.isBusy = true;     
       const Obj={
        subcat_id: this.sub_cat
       }
      axios.post(`${CONSTANTS.API_URL}/getPoTypeList`,Obj)
      .then(response => {
        // document.getElementById("overlay").style.display = "none";
        this.result = response.data

        if (this.result.returnmsg === 'Successful') {
          this.po_typearr  = this.result.returnvalue;
          this.totalRows = this.result.returnvalue.length;
          // this.isBusy = !this.isBusy;
          
        }else {
         this.po_typearr =[];
         this.totalRows=0;
           this.isBusy = !this.isBusy;
        }


      })
      .catch(e => {
        this.errors.push(e)
      })
    },

  /******Function To Get PO Type List Ends********/

   zoomin: function(){
        var myImg = document.getElementById("map");
        var currWidth = myImg.clientWidth;
        if(currWidth >= 2500) return false;
         else{
            myImg.style.width = (currWidth + 100) + "px";
        } 
    },
    zoomout: function(){
        var myImg = document.getElementById("map");
        var currWidth = myImg.clientWidth;
        if(currWidth <= 270) return false;
     else{
            myImg.style.width = (currWidth - 100) + "px";
        }
    },
        openimagecancel: function(){
      this.openimagemodel = !this.openimagemodel;
     },
     
            // Function For Action on status
    updatestylestatus: function(comment,value) {
      console.log("LLLLLLLLLLLLLLLLLLLLLLLLL",value);

      document.getElementById("overlay").style.display = "block";
      var status = value;
      var comment = comment;
           var userData = localStorage.getItem('userData');
           var userInfo = JSON.parse(userData)
           var user_id = userInfo[0].user_id; 
           // return false;
      if(status!=''){       
      const Obj={
        operational_status: status,
        updated_by: userInfo[0].email_id,
        user_id: userInfo[0].user_id,
        style_id: this.selected_style_id,
        comments : comment
      } 
      axios.post(`${CONSTANTS.API_URL}/updatestylestatus`,Obj)
      .then(response => {
        document.getElementById("overlay").style.display = "none";
        this.result = response.data
        if (this.result.returnmsg === 'Successful') {
          // alert("Status Updated Successfully");
          this.$fire({
                text:"Status Updated Successfully",
                type: "success",
                timer: 30000
                      })
          this.showdesigndetails = !this.showdesigndetails;
          this.getdesignheadstyledetails(); 
        }else {
         // alert("Please Check Status");
          this.$fire({
                text:"Please Check Status",
                type: "warning",
                timer: 30000
                      })
          
        }


      })
      .catch(e => {
        this.errors.push(e)
      })
    }
    else{
      document.getElementById("overlay").style.display = "none";
      this.$fire({
                text:"Please Check Status",
                type: "warning",
                timer: 120000
                      })
    }
    },

    commentcancel: function(){
      
      this.showdesigndetails = !this.showdesigndetails;
      // this.isBusy = !this.isBusy;
    },
    
        
           /****** Function to design details ********/
       getdesigndetail: function () {
         document.getElementById("overlay").style.display = "block";
   
           this.isBusy = true;
       
           const Obj = {
                style_id: this.selected_style_id 
                             
              }
           axios.post(`${CONSTANTS.API_URL}/getdesigndetail`,Obj)
           .then(response => {
            document.getElementById("overlay").style.display = "none";
             this.result = response.data
             if (this.result.returnmsg === 'Successful') {
              
            this.style_details  = this.result.returnvalue[0];
            this.img_path = this.style_details.style_image;
            // this.totalRows = this.result.returnvalue.length;
            this.isBusy = !this.isBusy; 
            this.sizeset = this.style_details.no_of_sizeset;
            console.log("########################",this.style_details.no_of_sizeset)
            this.temp_style_description=this.style_details.style_description;
            this.temp_style_name = this.style_details.style_name;
            this.temp_style_image = this.style_details.style_image;
            this.fileObj_msg = this.result.returnvalue[1].file_name;
            this.selected_status_code_number = this.style_details.status_code_number;
            // this.totalRows = this.result.returnvalue.length;
            console.log("########################",this.style_details)

           var temp_selected_unit= this.style_details.size_details[0].unit[0];

            var temp_selected_fromage= this.style_details.size_details[0].selectedfromage[0];
            
            var temp_selected_toage=this.style_details.size_details[0].selectedtoage[0];
            
               console.log("^^^^^^^^^^^^^^^^^^^^^^^^",temp_selected_unit)
               // var temp_qty=this.quotationlist.size_details[0].quantity[0];
               // console.log("))))))))))))))))))))",this.quotationlist.size_details[0].quantity[0].length);
               // for( var i =0 ; i<this.style_details.size_details[0].selectedfromage[0].length;i++){
               //  this.selected_month[i]=temp_selected_unit[i];
               //  this.selectedfromage[i]=temp_selected_fromage[i];
               //  this.selectedtoage[i]= temp_selected_toage[i];
               
               // } 

               if(this.style_details.status_code_number>=12 && this.style_details.status_code_number!=13){
              var temp_factorysize= this.style_details.size_details[0].factorysize[0];
            }
            if(this.style_details.status_code_number>=15 ){

              var temp_qty= this.style_details.size_details[0].quantity[0];
            }
            
            for( var i =0 ; i<this.style_details.size_details[0].selectedfromage[0].length;i++){
                this.tbl_selected_month[i]=temp_selected_unit[i];
                this.tbl_selectedfromage[i]=temp_selected_fromage[i];
                this.tbl_selectedtoage[i]= temp_selected_toage[i];
                if(this.style_details.status_code_number>=12 && this.style_details.status_code_number!=13){
                  this.tbl_factorysize[i]= temp_factorysize[i];
                }
                 if(this.style_details.status_code_number>=15){

                  this.tbl_quantity[i]= temp_qty[i];
               
                }
               }  
                          
             }else {
              this.style_details =[];
              this.totalRows=0;
                this.isBusy = !this.isBusy;
             }
   
   
           })
           .catch(e => {
             this.errors.push(e)
           })
   
   
       },

    onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },


      opendesignModal(value) {

        this.comment= '';
        this.status= '';
        this.selected_style_id = value.style_id;
        this.getdesigndetail();
        this.customer.brand_title = value.brand_title;
        this.customer.segment_title = value.segment_title;
        this.customer.collection_title = value.collection_title;
        this.customer.style_name = value.style_name;
        // this.getdesigndetail();
        this.showdesigndetails =true;
        
 },
  //Table Set Function
       opentable:function(){
           this.opentablemodel=!this.opentablemodel;
       },
       opentablecancel:function(){
           this.opentablemodel=!this.opentablemodel;
       },
     
    styledropdown:function(){
      var typelisting = document.getElementById("typelist");
  if (typelisting.style.display === "block") {
    typelist.style.display = "none";
  } else {
    typelisting.style.display = "block";
  }
   
      // document.getElementById('typelist').style.display="none";
    
    },
    // opentablecancel:function(){
    //        this.opendropdownmodel=!this.opendropdownmodel;
    //    },

    getdesignheadstyledetails: function() 
    {
      var userData = localStorage.getItem('userData');
          var userInfo = JSON.parse(userData)
        this.access_token=userInfo[0]['token']
        axios.defaults.headers.common['x-access-token'] = this.access_token;
        axios.defaults.headers.common['Content-Type'] = 'application/json;charset=UTF-8'
        axios.defaults.headers.common['Accept']= 'application/json';
        axios.defaults.headers.common['Origin']='http://localhost:8080';
      // document.getElementById("overlay").style.display = "block";
      this.isBusy = !this.isBusy;
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      this.login_user_id = userInfo[0].user_id;
      if(userInfo[0].user_type=='Admin'){
        const Obj={
            user_type: userInfo[0].user_type,
            keyword: this.$route.params.id,
            po_id: this.search_po,
            utility_id: this.search_utility,
            sub_catid: this.search_subcat,
            search_value: this.search_item,
            downloadalldata : 'no',
          }



        axios.post(`${CONSTANTS.API_URL}/getfashionheadstyledetails`,Obj).then(response => {
          document.getElementById("overlay").style.display = "none";
          this.result = response.data

          if (this.result.returnmsg === 'Successful') {
            
            this.items  = this.result.returnvalue; 

            this.list_totalRows = this.result.returnvalue.length;
            this.isBusy = !this.isBusy;
            
          }else {
            this.isBusy = false;
           this.items =[];
           this.list_totalRows=0;
             // this.isBusy = !this.isBusy;
          }


        })
        .catch(e => {
          this.errors.push(e)
        })
      }
      else if(userInfo[0].user_type=='Brand_Manager' || userInfo[0].user_type=='Buyer'){
      const Obj = {
               user_id : this.login_user_id,
               user_type : userInfo[0].user_type,
               keyword: this.$route.params.id,
               brand_id: userInfo[0].brand_assign,
               po_id: this.search_po,
               utility_id: this.search_utility,
               sub_catid: this.search_subcat,
               search_value: this.search_item  
              // user_id : 25
            }
            
     
        axios.post(`${CONSTANTS.API_URL}/getdashboardlistingforbrandmangerandbuyer`,Obj)
        .then(response => {
          document.getElementById("overlay").style.display = "none";
          this.result = response.data

          if (this.result.returnmsg === 'Successful') {
            
            this.items  = this.result.returnvalue; 

            this.style_image= this.items[0].style_image;
            this.operational_status = this.items.operational_status;
            this.list_totalRows = this.result.returnvalue.length;
            this.isBusy = !this.isBusy;
            
          }else {
            this.isBusy = false;
           this.items =[];
           this.list_totalRows=0;
             // this.isBusy = !this.isBusy;
          }


        })
        .catch(e => {
          this.errors.push(e)
        })
      }
      else if(userInfo[0].user_type=='Brand_Designer'){
      const Obj = {
               user_id : this.login_user_id,
               user_type : userInfo[0].user_type,
               keyword: this.$route.params.id,
               brand_id: userInfo[0].brand_assign,
               po_id: this.search_po,
               utility_id: this.search_utility,
               sub_catid: this.search_subcat,
               search_value: this.search_item
              // user_id : 25
            }
     
        axios.post(`${CONSTANTS.API_URL}/getdesignerstyledetails`,Obj)
        .then(response => {
          document.getElementById("overlay").style.display = "none";
          this.result = response.data

          if (this.result.returnmsg === 'Successful') {
            
            this.items  = this.result.returnvalue; 
            this.operational_status = this.items.operational_status;
            
            this.list_totalRows = this.result.returnvalue.length;
            this.isBusy = !this.isBusy;
            
          }else {
            this.isBusy = false;
           this.items =[];
           this.list_totalRows=0;
             // this.isBusy = !this.isBusy;
          }


        })
        .catch(e => {
          this.errors.push(e)
        })
      }
      else if(userInfo[0].user_type=='Fit_Technician'){
      const Obj = {
               user_id : this.login_user_id,
               user_type : userInfo[0].user_type,
               keyword: this.$route.params.id,
               brand_id: userInfo[0].brand_assign,
               po_id: this.search_po,
               utility_id: this.search_utility,
               sub_catid: this.search_subcat,
               search_value: this.search_item
              // user_id : 25
            }
     
        axios.post(`${CONSTANTS.API_URL}/getdashboardlistingforfit_tech`,Obj)
        .then(response => {
          document.getElementById("overlay").style.display = "none";
          this.result = response.data

          if (this.result.returnmsg === 'Successful') {
            
            this.items  = this.result.returnvalue; 
            this.operational_status = this.items.operational_status;
            
            this.list_totalRows = this.result.returnvalue.length;
            this.isBusy = !this.isBusy;
            
          }else {
            this.isBusy = false;
           this.items =[];
           this.list_totalRows=0;
             // this.isBusy = !this.isBusy;
          }


        })
        .catch(e => {
          this.errors.push(e)
        })
      }
      else if(userInfo[0].user_type=='Quality_Controller'){
      const Obj = {
               user_id : this.login_user_id,
               user_type : userInfo[0].user_type,
               keyword: this.$route.params.id,
               brand_id: userInfo[0].brand_assign,
               po_id: this.search_po,
               utility_id: this.search_utility,
               sub_catid: this.search_subcat,
               search_value: this.search_item
              // user_id : 25
            }
    
        axios.post(`${CONSTANTS.API_URL}/getdashboardlistingforqualitycontrol`,Obj)
        .then(response => {
          document.getElementById("overlay").style.display = "none";
          this.result = response.data

          if (this.result.returnmsg === 'Successful') {
            
            this.items  = this.result.returnvalue; 
            this.operational_status = this.items.operational_status;
            
            this.list_totalRows = this.result.returnvalue.length;
            this.isBusy = !this.isBusy;
            
          }else {
            this.isBusy = false;
           this.items =[];
           this.list_totalRows=0;
             // this.isBusy = !this.isBusy;
          }


        })
        .catch(e => {
          this.errors.push(e)
        })
      }
      else if(userInfo[0].user_type=='Quality_Executive'){
      const Obj = {
               user_id : this.login_user_id,
               user_type : userInfo[0].user_type,
               keyword: this.$route.params.id,
               brand_id: userInfo[0].brand_assign,
               po_id: this.search_po,
               utility_id: this.search_utility,
               sub_catid: this.search_subcat,
               search_value: this.search_item
              // user_id : 25
            }
    
        axios.post(`${CONSTANTS.API_URL}/getdashboardlistingforQC_Executive`,Obj)
        .then(response => {
          document.getElementById("overlay").style.display = "none";
          this.result = response.data

          if (this.result.returnmsg === 'Successful') {
            
            this.items  = this.result.returnvalue; 
            this.operational_status = this.items.operational_status;
            
            this.list_totalRows = this.result.returnvalue.length;
            this.isBusy = !this.isBusy;
            
          }else {
            this.isBusy = false;
           this.items =[];
           this.list_totalRows=0;
             // this.isBusy = !this.isBusy;
          }


        })
        .catch(e => {
          this.errors.push(e)
        })
      }
      else{
        // var userData = localStorage.getItem('userData');
        // var userInfo = JSON.parse(userData)
      const Obj = {
               user_id : this.login_user_id,
               user_type : userInfo[0].user_type,
               keyword: this.$route.params.id,
               brand_id: userInfo[0].brand_assign,
               brand_manager: userInfo[0].brand_manager,
               po_id: this.search_po,
               utility_id: this.search_utility,
               sub_catid: this.search_subcat,
               search_value: this.search_item 
              // user_id : 25
            }
     
        axios.post(`${CONSTANTS.API_URL}/getdesignheadstyledetails`,Obj)
        .then(response => {
          document.getElementById("overlay").style.display = "none";
          this.result = response.data

          if (this.result.returnmsg === 'Successful') {
            
            this.items  = this.result.returnvalue; 
            
            this.list_totalRows = this.result.returnvalue.length;
            this.isBusy = !this.isBusy;
            
          }else {
            this.isBusy = false;
           this.items =[];
           this.list_totalRows=0;
             // this.isBusy = !this.isBusy;
          }


        })
        .catch(e => {
          this.errors.push(e)
        })
      }
    },

  }
};
</script>
<style>
.account-settings__content>* {
    flex-grow: 1;
}

.profile-settings {
    flex-grow: 1;
    padding: 20px 24px;
}

.profile-settings>h1 {
    font-weight: 600;
    padding: 0;
    margin: 0;
}
.profile-settings .content {
    display: flex;
}
.profile-settings .content .profile-fields-container {
    max-width: 356px;
    margin-right: 56px;
}
.profile-settings .tabular-fields {
    font-size: 14px;
    line-height: 20px;
    flex-direction: column;
}
.profile-settings .tabular-fields .field-row {
    margin-top: 20px;
    min-height: 44px;
    display: flex;
    flex-direction: row;
    align-items: center;
}
.profile-settings .tabular-fields .field-row>.field-label {
    color: var(--fill-grey-medium);
    min-width: 100px;
    margin: 12px 0;
}
.profile-settings .tabular-fields .field-row>.field-value {
    margin-left: 32px;
    flex-grow: 1;
}

.design-container-details__main{
 
  background-color:white;
  border-left:1px solid #d4d4d4;

}

.profile-settings .content .img.img-invalid {
    background-color: #6f4ce6;
}
.profile-settings .content .img {
    max-width: 100%;
    position: relative;
    height: 175px;
    width: 175px;
    border-radius: 4px;
    overflow: hidden;
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: contain;
    border: 1px solid var(--fill-grey-light2);
    padding: 5px;
}

   /*****CSS For Zoom Image*****/
   *body {
  margin: 0;
}
#btn_navbar {
  overflow: hidden;
  text-align: center;
  /*position: fixed;*/
  top: 0;
  width: 100%;
  padding-top: 3px;
  padding-bottom: 3px;
  padding-left: 20px;
}
#btn_navbar a {
  float: left;
  display: block;
  color: #666;
  text-align: center;
  padding-right: 20px;
  text-decoration: none;
  font-size: 17px;
}
#btn_navbar a:hover {
  background-color: #ddd;
  color: black;
}
#btn_navbar a.active {
  background-color: #4CAF50;
  color: white;
}
.main1 {
  padding: 16px;
  margin-top: 30px;
}
.main1 img {
  max-width: 100%;
  height: auto;

}
.button {
  width: 300px;
  height: 60px;
}

.detailimgborder{
  width:350px;
  float: left;
  border: 1px solid lightgray;
}
.detailsmodalimg{
  height:350px; 
  width:350px; 
  padding:5px;
}
.summaryzoombtn{
  padding:5px;
  margin-left: 30%;
  margin-bottom: 10px;
}
@media screen and (max-width: 1040px){
 .summarytableset{
  display: none;
}
}
@media screen and (min-width: 1040px){
 .tablemd{
  display: none;
 }
 }
 @media screen and (max-width: 530px){
 #tablesm{
  display: none;
 }
 }
@media screen and (max-width: 1040px) and (min-width: 992px){
 .summarymodel{
    flex: 0 0 50%;
    max-width: 47%;
}
}
@media screen and (max-width: 990px){
 .summarymodel{
    flex: 0 0 50%;
    max-width: 47%;
}
.designsummaryipad{
   flex: 0 0 90%;
    max-width: 100%;
}
.detailsmodalimg{
  height:180px; 
  width:200px; 
  padding:5px;
}
.detailimgborder{
  width:205px;
  float: left;
  border: 1px solid lightgray;
}
.designsummary{
  margin-top: 10px;
}

}
@media screen and (max-width: 766px) and (min-width: 480px){
 /*.summarymodel{
    flex: 0 0 50%;
    max-width: 47%;
}
.designsummaryipad{
   flex: 0 0 90%;
    max-width: 100%;
}*/
.detailsmodalimg{
  height:150px; 
  width:250px; 
  padding:5px;
}
.detailimgborder{
  width:255px;
  float: left;
  border: 1px solid lightgray;
}
.designsummary{
  margin-top: 10px;
}
.designsummarycol5{
  width:120px ;
}
.designsummarycol1{
  width:10px ;
}

}
@media screen and (max-width: 479px) and (min-width: 350px){
  .summarymodel{
    flex: 0 0 50%;
    max-width: 20%;
}
  .detailsmodalimg{
  height:100px; 
  width:200px; 
  padding:5px;
}
.detailimgborder{
  width:200px;
  float: left;
  border: 1px solid lightgray;
}
.designsummary{
  margin-top: 10px;
  padding-left: 0px;
}
.designsummaryipad{
   font-size:12px;
}
.designsummarycol1{
  width:10px;
}
.designsummarycol5{
  width:115px ;
}
}
@media screen and (max-width: 349px){
  .summarymodel{
    flex: 0 0 50%;
    max-width: 15%;
}
  .detailsmodalimg{
  height:100px; 
  width:150px; 
  padding:5px;
}
.detailimgborder{
  width:150px;
  float: left;
  border: 1px solid lightgray;
}
.designsummary{
  margin-top: 10px;
  padding-left: 0px;
}
.designsummaryipad{
   font-size:11px;
}
.summaryzoombtn{
  padding:5px;
  margin-left: 25%;
  margin-bottom: 10px;
  font-size:10px;
}
.designsummarycol1{
  width:10px;
}
.designsummarycol5{
  width:80px ;
}
}
 .pagination a {
  color: black;
  float: left;
  padding: 8px 16px;
  text-decoration: none;
  transition: background-color .3s;
  border: 1px solid #ddd;
}


.page-item.active {
  background-color: #87CEEB;
    color: white;
    padding-bottom: 0px;
}

.pagination a:hover:not(.active) {background-color: #ddd;}

@media(max-width: 450px){
  .sumtdhset{
    font-size:10px;
  }
  .sumtdhunit{
    font-size:10px;
  }
  .sumtdhagefrom{
    font-size:10px;
  }
  .sumtdhageto{
    font-size:10px;
  }
  .sumtdhsize{
    font-size:10px;
  }
  .sumtdhquantity{
    font-size:10px;
  }
  .sumtdbquantity{
    width:60px;
  }
  .sumtdbsize{
     width:60px;
  }
  .sumtdbunit{
    padding:0px;
    height: 33px !important;
     width:50px;
  }
   .sumtdbfage{
    padding:0px;
    height: 33px !important;
     width:50px;
  }
  .sumtdbtage{
    padding:0px;
    height: 33px !important;
     width:50px;
  } 
  .detailimgborder{
    margin-top: -26px;
  }


}

 

</style>


